import { DateTime } from 'luxon';

// Converts a JS Date (browser timezone) to a Luxon DateTime in the provided timezone,
// keeping the clock values intact.
export function BrowserJSDateToOrgLuxonDateTime(
  date: Date,
  timezone: string
) {
  return DateTime.fromJSDate(date, { zone: 'local' }).setZone(timezone, {
    keepLocalTime: true,
  });
}
